var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("路由：登录与注册[杜老师]")]),_c('hr'),_c('div',{staticClass:"login-container"},[_c('router-link',{attrs:{"to":"/login","tag":"span"}},[_vm._v("登录")]),_c('router-link',{attrs:{"to":"/register","tag":"span"}},[_vm._v("注册")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }